import React, {
	createContext,
	useEffect,
	useState,
	useReducer
  } from 'react';
  import _ from 'lodash';
  import { THEMES } from 'src/constants';
  
  const defaultMenu = {
	selectedMenu: 'Overview' 
  };
  
  export const restoreMenu = () => {
	let menu = null;
  
	try {
	  const storedData = window.localStorage.getItem('menu');
  
	  if (storedData) {
		menu = JSON.parse(storedData);
	  }
	} catch (err) {
	  console.error(err);
	  // If stored data is not a strigified JSON this will fail,
	  // that's why we catch the error
	}
  
	return menu;
  };
  
  
  export const storeMenu = (menu) => {
	window.localStorage.setItem('menu', JSON.stringify(menu));
  };
  
  const reducer = (state, action) => { //state가 비어 있으면 빈 상태의 state가 사용된다.
	switch (action.type) {
	  case 'CLICKED': {
		const { selectedMenu } = action.payload; 
  
		return {
		  ...state,
		  selectedMenu: selectedMenu

		};
	  }
	  default: {
		return { ...state };
	  }
	}
  };

  const MenuContext = createContext({
	menu: defaultMenu,
	saveMenu: () => { }
  });
  
  export const MenuProvider = ({ children }) => {
	// const [currentMenu, setCurrentMenu] = useState(menu || defaultMenu);
	const [state, dispatch] = useReducer(reducer, defaultMenu);

	const handleSaveMenu = () => {
	//   const mergedMenu = _.merge({}, currentMenu, update);
	  const selectedMenu = 'selectedMenu'
	//   setCurrentMenu(selectedMenu);
	  storeMenu(selectedMenu);
	  dispatch({
		  type: 'CLICKED',
		  payload: {
			selectedMenu
		  }
	  })
	};
  
	// useEffect(() => {
	//   const restoredMenu = restoreMenu();
  
	//   if (restoredMenu) {
	// 	setCurrentMenu(restoredMenu);
	//   }
	// }, []);
  
	// useEffect(() => {
	//   document.dir = currentMenu.direction;
	// }, [currentMenu]);
  
	return (
	  <MenuContext.Provider
		value={{
		  menu: state,
		  saveMenu: handleSaveMenu
		}}
	  >
		{children}
	  </MenuContext.Provider>
	);
  };
  
  export const MenuConsumer = MenuContext.Consumer;
  
  export default MenuContext;
  